import {capitalizeFirstLetter} from "utils/lib";
import {
  FLAT_DISCOUNT_ALREADY_APPLIED,
  PROMO_ALREADY_APPLIED,
} from "../components/pages/PromosCityLevel/PromosCityLevelTableConstants";

import {
  ICategoryListingNormalizedData,
  IcreateUserPayload,
  IDeliveryOption,
  IGlobalProductDetailsResponse,
  IGlobalProductPayload,
  INormalizedProductInventory,
  IOdooTaxListResponse,
  IOdooTaxResponse,
  IProductInventory,
  IProductInventoryPayload,
  IPromoProductSearchNormalized,
  IWarehousePayload,
} from "../interfaces/Index";

export const normalizeGlobalProductReqPayload = (
  state: IGlobalProductPayload,
  productUomStock: any
) => {
  let jsonData: any = {};
  let formData: any = new FormData();
  const imageData =
    state.productImage && (state.productImage! as any).multiPartData
      ? (state.productImage! as any).multiPartData
      : "";

  formData.append("image", imageData);
  jsonData.sku = state.productSku;
  jsonData.title = state.productTitle;
  jsonData.description = state.productDescription;
  jsonData.status = state.status ? "ACTIVE" : "INACTIVE";
  jsonData.categoryId = state.commandoProductCategories;
  jsonData.productType = (state.productType as any).id;
  jsonData.brand = (state.brand as any).id;
  jsonData.vendor = state.productVendor;
  jsonData.inventory = {
    stock: state.productStock,
    policy: state.continueSelling ? "continue" : "deny",
  };
  jsonData.originalPrice = state.productOriginalPrice;
  jsonData.displayPrice = state.productDisplayPrice;
  jsonData.retailPrice = state.productRetailPrice;
  jsonData.unitsOfMeasure = {
    purchase: (state.productUomPurchase as any).id,
    stock: productUomStock.id,
    sales: (state.productUomSales as any).id,
  };
  jsonData.channels = state.channels;
  jsonData.tax = {
    salesTaxId: state.sellingTax,
    purchaseTaxId: state.purchaseTax,
  };
  jsonData.cities = state.cities.map((cityId) => {
    return cityId.id;
  });
  jsonData.customerChannels = state.customerChannels.map((channel) => {
    return channel.id;
  });
  jsonData.barcodesDto = {
    purchase: state.productBarcodePurchase,
    stock: state.productBarcodeInventory,
    sales: state.productBarcodeSales,
  };
  jsonData.productVariantPropertiesDto = {
    weight: {
      value: parseFloat(state.productWeightValue!!),
      unit: (state.productWeightUnit as any).key
        ? (state.productWeightUnit as any).key
        : state.productWeightUnit,
    },
    purchase:
      state.purchase && state.purchase.dimensions
        ? state.purchase
        : {
            dimensions: {},
            stackingHeight: 0,
          },
    sales:
      state.sales && state.sales.dimensions
        ? state.sales
        : {
            dimensions: {},
            stackingHeight: 0,
          },
    stock:
      state.stock && state.stock.dimensions
        ? state.stock
        : {
            dimensions: {},
            stackingHeight: 0,
          },
  };

  jsonData.productVariantOptionalPropertiesDto = {
    shelfLife:
      state.optionalProperties && state.optionalProperties.shelfLife
        ? state.optionalProperties.shelfLife
        : 0,
  };

  return { formData, jsonData };
};

export const normalizeGlobalProductUpdateReqPayload = (
  state: IGlobalProductPayload,
  productUomStock: any
) => {
  let jsonData: any = {};
  let formData: any = new FormData();
  const objectPair = (e: any) => {
    if (typeof e === "string") {
      return e;
    } else {
      return e.id;
    }
  };
  const imageData =
    state.productImage && (state.productImage! as any).multiPartData
      ? (state.productImage! as any).multiPartData
      : "";
  if (imageData) {
    formData.append("image", imageData);
    jsonData.shopifyImageId = null;
  }
  jsonData.sku = state.productSku;
  jsonData.title = state.productTitle;
  jsonData.description = state.productDescription;
  jsonData.status = state.status ? "ACTIVE" : "INACTIVE";
  jsonData.categoryId = state.commandoProductCategories;
  jsonData.productType = objectPair(state.productType);
  jsonData.brand = (state.brand as any).id;
  jsonData.variantId = state.variantId as string;
  jsonData.vendor = state.productVendor;
  jsonData.sku = state.productSku;
  jsonData.channels = state.channels;
  jsonData.inventory = {
    inventoryItemId: state.inventoryId,
    stock: state.productStock,
    policy: state.continueSelling ? "continue" : "deny",
  };
  jsonData.originalPrice = state.productOriginalPrice;
  jsonData.displayPrice = state.productDisplayPrice;
  jsonData.retailPrice = state.productRetailPrice;
  jsonData.unitsOfMeasure = {
    purchase: objectPair(state.productUomPurchase),
    stock: productUomStock.id,
    sales: objectPair(state.productUomSales),
  };
  jsonData.tax = {
    salesTaxId: state.sellingTax,
    purchaseTaxId: state.purchaseTax,
  };
  jsonData.cities = state.cities.map((cityId) => {
    return cityId.id;
  });
  jsonData.customerChannels = state.customerChannels.map((channel) => {
    return channel.id;
  });
  jsonData.barcodesDto = {
    purchase: state.productBarcodePurchase,
    stock: state.productBarcodeInventory,
    sales: state.productBarcodeSales,
  };

  jsonData.productVariantOptionalPropertiesDto = {
    shelfLife:
      state.optionalProperties && state.optionalProperties.shelfLife
        ? state.optionalProperties.shelfLife
        : 0,
  };

  jsonData.productVariantPropertiesDto = {
    weight: {
      value: parseFloat(state.productWeightValue!!),
      unit: (state.productWeightUnit as any).key
        ? (state.productWeightUnit as any).key
        : state.productWeightUnit,
    },
    purchase:
      state.purchase && state.purchase.dimensions
        ? state.purchase
        : {
            dimensions: {},
            stackingHeight: 0,
          },
    sales:
      state.sales && state.sales.dimensions
        ? state.sales
        : {
            dimensions: {},
            stackingHeight: 0,
          },
    stock:
      state.stock && state.stock.dimensions
        ? state.stock
        : {
            dimensions: {},
            stackingHeight: 0,
          },
  };

  return { formData, jsonData };
};

export const normalizeFetchProductResponse = (
  res: Array<IcreateUserPayload>,
  pagination: any,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 25 ? pagination : false,
    isPaginatedRes,
  };
  const productPayload = res.map((product) => {
    return {
      id: product.id,
      variantId: product.variantId,
      productSku: product.sku || "",
      productTitle: product.title || product.name,
      productDescription: product.description || "",
      productCategories: product.category || "",
      categoryId: product.categoryId || "",
      productTags: product.tags || [],
      productVendor: product.vendor || "",
      productStock: product.availableStock || product.stock,
      productOriginalPrice: product.actualPrice || 0,
      retailPrice: product.retailPrice || 0,
      productDisplayPrice: product.discountedPrice || 0,
      status: product.status || "",
      productImage: product.imageUrl || "",
      productWeight: {
        productWeightValue: "",
        productWeightUnit: "",
      },
      isChecked: false,
      channels: product.channels || [],
      uomSale: product.uomSale || "",
      cities: product.cities || [],
      purchaseTaxId: product.purchaseTaxId || "",
      salesTaxId: product.salesTaxId || "",
      brandId: product.brandId || "",
    };
  });
  payload.productData = productPayload;
  return payload;
};


export const normalizeFetchProductResponseForPromo = (
    res: Array<IcreateUserPayload>,
    pagination: any,
    isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 25 ? pagination : false,
    isPaginatedRes,
  };
  const productPayload = res.map((product) => {
    return {
      id: product.id,
      variantId: product.variantId,
      productSku: product.sku || "",
      productTitle: product.title || product.name,
      productDescription: product.description || "",
      productCategories: product.category || "",
      categoryId: product.categoryId || "",
      productTags: product.tags || [],
      productVendor: product.vendor || "",
      productStock: product.availableStock || product.stock,
      productOriginalPrice: product.originalPrice || 0,
      productDisplayPrice: product.displayPrice  || 0,
      status: product.status || "",
      productImage: product.imageUrl || "",
      productWeight: {
        productWeightValue: "",
        productWeightUnit: "",
      },
      isChecked: false,
      channels: product.channels || [],
      uomSale: product.uomSale || "",
      cities: product.cities || [],
      purchaseTaxId: product.purchaseTaxId || "",
      salesTaxId: product.salesTaxId || "",
      brandId: product.brandId || "",
    };
  });
  payload.productData = productPayload;
  return payload;
};

export const normalizeBulkUploadPayload = (file: any) => {
  let formData = new FormData();
  formData.append("file", file);
  return formData;
};

export const normalizeGlobalProductDetailsResponse = (
  data: IGlobalProductDetailsResponse
) => {
  return {
    productSku: data.sku || "",
    productTitle: data.title || "",
    productDescription: data.description || "",
    commandoProductCategories: data.categoryId,
    categoryId: data.categoryId,
    productType: data.productType,
    brand: data.brand,
    productUomPurchase: data.unitsOfMeasure && data.unitsOfMeasure.purchase,
    productUomStock: data.unitsOfMeasure && data.unitsOfMeasure.stock,
    productUomSales: data.unitsOfMeasure && data.unitsOfMeasure.sales,
    productVendor: data.vendor || "",
    productStock: data.inventory ? data.inventory.stock : "0",
    inventoryId: data.inventory
      ? data.inventory.inventoryItemId.toString()
      : "",
    variantId: data.variantId.toString(),
    productOriginalPrice: "",
    productDisplayPrice: "",
    productRetailPrice: "",
    productImage: {
      imageId: data.imageId,
      base64StringUrl: data.imageUrl,
    },
    status: data.status === "INACTIVE" ? false : true,
    continueSelling: data.inventory
      ? data.inventory.policy === "deny"
        ? false
        : true
      : true,
    productWeightValue: data.weight
      ? data.weight.unit
        ? data.weight.value.toString()
        : ""
      : "",
    productWeightUnit: data.weight ? data.weight.unit : "",
    customerApp: data.customerApp === "CUSTOMER_APP" ? true : false,
    agentApp: data.agentApp === "AGENT_APP" ? true : false,
    adminCommando: data.adminCommando === "ADMIN_COMMANDO" ? true : false,
    channels: data.channels,
    sellingTax: data.tax ? data.tax.salesTaxId : "",
    purchaseTax: data.tax ? data.tax.purchaseTaxId : "",
    cities: data.cities.map((cityId) => {
      return { id: cityId, name: "dummy" };
    }),
    customerChannels: data.customerChannels.map((customerChannel) => {
      return { id: customerChannel, title: customerChannel };
    }),
    productBarcodePurchase: data.barcodesDto.purchase,
    productBarcodeInventory: data.barcodesDto.stock,
    productBarcodeSales: data.barcodesDto.sales,
    optionalProperties: data.optionalProperties
      ? data.optionalProperties
      : {
          shelfLife: 0,
        },
    purchase: data.purchase
      ? data.purchase
      : {
          stackingHeight: "0",
          dimensions: {
            length: 0,
            height: 0,
            width: 0,
          },
        },
    sales: data.sales
      ? data.sales
      : {
          stackingHeight: "0",
          dimensions: {
            length: 0,
            height: 0,
            width: 0,
          },
        },
    stock: data.stock
      ? data.stock
      : {
          stackingHeight: "0",
          dimensions: {
            length: 0,
            height: 0,
            width: 0,
          },
        },
  };
};

export const normalizeProductCategories = (categories: any) => {
  return categories.map((cat: any) => {
    return {
      id: cat.id,
      title: cat.title,
      key: cat.title,
      label: cat.title,
    };
  });
};

export const normalizeProductType = (productTypes: any) => {
  return productTypes.map((type: any) => {
    return {
      id: type.id,
      key: type.id,
      title: type.value,
      label: type.value,
    };
  });
};

export const normalizeProductUom = (uoms: any) => {
  return uoms.map((uom: any) => {
    return {
      id: uom.id,
      key: uom.id,
      title: uom.name,
      label: uom.name,
    };
  });
};

export const normalizeProductCommandoCategories = (
  categories: Array<ICategoryListingNormalizedData>
) => {
  let parentIndex: number | null = null;

  categories.forEach((item, index) => {
    let title = "";
    if (item.parentId) {
      title = `${categories[parentIndex as number].categoryTitle}/${
        item.categoryTitle
      }`;
      item.title = title;
      item.label = title;
      item.key = item.id;
    } else {
      title = item.categoryTitle;
      item.title = title;
      item.label = title;
      item.key = item.id;
      parentIndex = index;
    }
  });
};

export const normalizeProductCommandoCategoriesWIthCities = (
  categoriesGlobal: Array<any>
) => {
  let parentIndex: number | null = null;

  categoriesGlobal.forEach((item, index) => {
    let title = "";
    if (item.parentId) {
      title = `${categoriesGlobal[parentIndex as number].categoryGlobalTitle}/${
        item.categoryGlobalTitle
      }`;
      item.title = title;
      item.key = item.id;
    } else {
      title = item.categoryGlobalTitle;
      item.title = title;
      item.label = title;
      item.key = item.id;
      item.label = item.title;
      parentIndex = index;
    }
  });
};

export const normalizeProductCityLevelSearchResult = (res: any) => {
  return res.map((item: any) => {
    return {
      id: item.id,
      variantId: item.variantId,
      itemName: item.productCityLevelTitle,
      title: item.productCityLevelTitle,
      itemPrice: item.productCityLevelDisplayPrice || 0,
      quantity: 1,
      discount:
        item.productCityLevelDisplayPrice !== 0
          ? item.productCityLevelOriginalPrice -
            item.productCityLevelDisplayPrice
          : 0,
      isChecked: false,
      additionalDiscount: 0,
      productOriginalPrice: item.productCityLevelOriginalPrice || 0,
      customerChannelAttributesMap: item.customerChannelAttributesMap,
      uomSale: item.uomSale,
      sku: item.productCityLevelSku,
      purchaseTaxId: item.purchaseTaxId || "",
      salesTaxId: item.salesTaxId || "",
      imageUrl: item.productImage || "",
      categoryId: item.categoryId || "",
    };
  });
};

export const normalizeOrderProductSearchResult = (res: any) => {
  return res.map((item: any) => {
    return {
      id: item.id,
      variantId: item.variantId,
      itemName: item.productTitle,
      title: item.productTitle,
      itemPrice: item.productDisplayPrice || 0,
      quantity: 1,
      discount:
        item.productDisplayPrice !== 0
          ? item.productOriginalPrice - item.productDisplayPrice
          : 0,
      isChecked: false,
      additionalDiscount: 0,
      productOriginalPrice: item.productOriginalPrice || 0,
      stock: item.productStock,
      uomSale: item.uomSale,
      sku: item.productSku,
      purchaseTaxId: item.purchaseTaxId || "",
      salesTaxId: item.salesTaxId || "",
      imageUrl: item.productImage || "",
      categoryId: item.categoryId || "",
      brandId: item.brandId || "",
      retailPrice: item.retailPrice || 0,
    };
  });
};

// 2 lists: 1 active products + 1 active promo
export const normalizePromoProductSearchResult = (
  res: any,
  activeProductWithPromos: string[]
): IPromoProductSearchNormalized[] => {
  const promoProducts: any = [];
  res.forEach((element: any) => {
    // Check condition here for volumetric and flat discount
    const payload: any = {
      id: element.id,
      variantId: element.variantId,
      itemName: element.productTitle,
      productOriginalPrice: element.productOriginalPrice,
      stock: element.productStock,
      isFlatDiscount: false,
      isVolumetricDiscount: false,
      itemAvailable: "",
      categoryStatus: true,
      productSku: element.productSku || "",
    };
    if (element.productDisplayPrice && element.productDisplayPrice > 0) {
      payload.isFlatDiscount = true;
      payload.itemAvailable = FLAT_DISCOUNT_ALREADY_APPLIED;
    } else if (activeProductWithPromos.includes(element.id)) {
      payload.isVolumetricDiscount = true;
      payload.itemAvailable = PROMO_ALREADY_APPLIED;
    }
    promoProducts.push(payload);
  });
  return promoProducts;
};

export const normalizeProductBrand = (productBrands: any) => {
  return productBrands.map((type: any) => {
    return {
      id: type.id,
      value: type.id,
      label: type.value,
    };
  });
};

export const normalizeOdooTax = (
  tax: IOdooTaxListResponse[] | IOdooTaxResponse
) => {
  if (Array.isArray(tax)) {
    return tax.map((t: IOdooTaxResponse) => {
      return {
        ...t,
        value: t.id,
        key: t.id,
        title: t.name,
        label: t.name,
        id: t.id,
      };
    });
  }
  return tax;
};

export const normalizeWareHouseNames = (
  wareHouseNames: any
): IWarehousePayload[] => {
  return wareHouseNames.map((data: any) => {
    return {
      id: data.id,
      name: data.name,
      latitude: data.latitude,
      longitude: data.longitude,
    };
  });
};

export const normalizeDeliveryOptions = (
  deliveryOptions: any
): IDeliveryOption[] => {
  return deliveryOptions.map((option: any) => {
    const label = capitalizeFirstLetter(option.replace("_", " ").toLowerCase());
    return {
      id: option,
      key: option,
      title: label,
      label,
    };
  });
};

export const normalizeProductInventory = (
  productInventory: IProductInventory[]
): INormalizedProductInventory[] => {
  return productInventory.map((data: IProductInventory) => {
    return {
      warehouseId: data.warehouseId,
      quantity: data.quantity,
      primeQuantity: data.primeQuantity
    };
  });
};

export const normalizeProductInventoryUpdateReqPayload = (
  state: IProductInventoryPayload
) => {
  return {
    productId: state.productId,
    inventoryDetails: state.inventoryDetails,
  };
};

export const normalizeIdValueResponse = (cities: any) => {
  return cities.map((city: any) => {
    return {
      ...city,
      key: city.id,
      value: city.id,
      title: city.name,
      label: city.name,
    };
  });
};
